import { Theme } from '@portal-shared/app/models/theme.model';

export const DefaultTheme: Theme = {
  selector: '',
  name: 'Default'
};
